export const selectProposalRecentActivityData = (state) =>
  state.proposals.recentActivity.data;

export const selectProposalRecentActivityLoading = (state) =>
  state.proposals.recentActivity.isLoading;

export const selectProposalRecentActivityError = (state) =>
  state.proposals.recentActivity.error;
